"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _react2 = require("swiper/react");
var _styles = require("@material-ui/core/styles");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _teaserSliderItem = _interopRequireDefault(require("../teaser-slider-item"));
require("swiper/swiper.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    margin: theme.spacing(0, -1),
    padding: theme.spacing(0, 1)
  }
}));
const TeaserSlider = props => {
  const {
    data,
    lang,
    mediaFormat,
    showBookmark
  } = props;
  const screenXS = (0, _useMediaQuery.default)(theme => theme.breakpoints.only("xs"));
  const screenSM = (0, _useMediaQuery.default)(theme => theme.breakpoints.only("sm"));
  const screenMD = (0, _useMediaQuery.default)(theme => theme.breakpoints.only("md"));
  const css = useStyles();
  const options = {
    spaceBetween: function () {
      if (screenXS) return 16;
      if (screenSM) return 24;
      return 24;
    },
    slidesPerView: function () {
      if (screenXS) return 1.25;
      if (screenSM) return 2.25;
      if (screenMD) return 3.25;
      return 3.25;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data && /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    className: css.root,
    spaceBetween: options.spaceBetween(),
    slidesPerView: options.slidesPerView()
  }, data.map((item, index) => {
    const {
      dateFrom,
      dateTo,
      id,
      link,
      media,
      title,
      timeFrom,
      timeTo
    } = item;
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: "".concat(index).concat(id)
    }, /*#__PURE__*/_react.default.createElement(_teaserSliderItem.default, {
      dateFrom: dateFrom,
      dateTo: dateTo,
      id: id,
      lang: lang,
      link: link,
      media: media,
      mediaFormat: mediaFormat,
      timeFrom: timeFrom,
      timeTo: timeTo,
      title: title,
      showBookmark: showBookmark
    }));
  }))));
};
TeaserSlider.defaultProps = {
  showBookmark: false
};
var _default = exports.default = TeaserSlider;